import { render, staticRenderFns } from "./shopGrantDetail.vue?vue&type=template&id=2d938cda&scoped=true&"
import script from "./shopGrantDetail.vue?vue&type=script&lang=js&"
export * from "./shopGrantDetail.vue?vue&type=script&lang=js&"
import style0 from "./shopGrantDetail.vue?vue&type=style&index=0&id=2d938cda&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d938cda",
  null
  
)

export default component.exports